exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".talk-box-wrapper {\n  width: 312px; }\n\n.talk-box-header {\n  padding: 10px 4px;\n  background: #404040;\n  font-size: 14px;\n  color: #ffffff;\n  display: flex;\n  align-items: center; }\n\n.talk-box-status {\n  color: #E53935;\n  padding: 0px 4px;\n  font-size: 16px; }\n  .talk-box-status.connected {\n    color: #43A047; }\n  .talk-box-status:before {\n    content: \"\\25CF\"; }\n\n.talk-box-body {\n  height: 320px;\n  overflow: auto;\n  background: #f3f3f3;\n  padding-bottom: 16px; }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/sass-loader/lib/loader.js!./style/talk-box.scss
// module id = 63
// module chunks = 0